import { createSelector } from '@reduxjs/toolkit';
import React from 'react';
import config from '../utils/constants/config';
import _ from 'lodash';
const messageProjections = {};

messageProjections.applicationMessageList = notificationCallback =>
    createSelector(
        state => state.message.byId,
        messagesById => {
            return Object.entries(messagesById).map(([key, value]) => {
                const notificationLabel = Array.isArray(value.message) ? (
                    <ul>
                        {value.message.map((error, index) => (
                            <li key={index} style={{ textAlign: 'center' }}>
                                {error}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div style={{ textAlign: 'center' }}>{value.message}</div>
                );

                if (notificationCallback) {
                    return {
                        key: value.uuid,
                        label: notificationLabel,
                        callback: notificationCallback,
                        variant: value.type,
                    };
                }

                return {
                    key: value.uuid,
                    label: notificationLabel,
                };
            });
        },
    );

messageProjections.totalErrorMessages = createSelector(
    state => state.message.byId,
    messagesById => {
        return Object.entries(messagesById).filter(
            ([key, value]) => value.type === config.StatusMessage.ERROR,
        ).length;
    },
);

export default messageProjections;
